import React, { useState, useEffect, useMemo } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Button, TextField, Box, Card } from '@mui/material';
import { getAcenteAccounts } from '../api/api';
import { toast } from "react-toastify";

const AcenteLists = () => {
  const [allAccounts, setAllAccounts] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchAccounts();
  }, []);

  const fetchAccounts = async () => {
    setLoading(true);
    try {
      const response = await getAcenteAccounts();
      if (response.isSuccess && response.value) {
        const accountsWithId = response.value.map((item, index) => ({
          ...item,
          id: item.accountId || index,
        }));
        setAllAccounts(accountsWithId);
      } else {
        toast.error('Acenteler yüklenemedi');
      }
    } catch (error) {
      toast.error('Bir hata oluştu: ' + error.message);
    } finally {
      setLoading(false);
    }
  }

  // Filtreleme işlemi
  const filteredAccounts = useMemo(() => {
    if (!filterText) return allAccounts;
    
    const searchLower = filterText.toLowerCase();
    return allAccounts.filter((account) =>
      account.accountName?.toLowerCase().includes(searchLower) ||
      account.accountId?.toLowerCase().includes(searchLower) ||
      account.city?.toLowerCase().includes(searchLower) ||
      account.taxNumber?.toLowerCase().includes(searchLower) ||
      account.phoneNumber?.toLowerCase().includes(searchLower) ||
      account.emailAddress?.toLowerCase().includes(searchLower) ||
      account.priceCode?.toLowerCase().includes(searchLower)
    );
  }, [allAccounts, filterText]);
  const columns = [
    { 
      field: 'accountName', 
      headerName: 'Acente Adı', 
      flex: 1,
      minWidth: 200,
    },
    // { 
    //   field: 'accountId', 
    //   headerName: 'Hesap ID', 
    //   flex: 1,
    //   minWidth: 200,
    // },
    { 
      field: 'relation', 
      headerName: 'İlişki', 
      width: 120,
    },
    { 
      field: 'accountType', 
      headerName: 'Hesap Tipi', 
      width: 120,
    },
    { 
      field: 'addressDetail', 
      headerName: 'Adres Detayı', 
      flex: 1,
      minWidth: 200,
    },
    { 
      field: 'city', 
      headerName: 'Şehir', 
      width: 120,
    },
    { 
      field: 'country', 
      headerName: 'Ülke', 
      width: 120,
    },
    { 
      field: 'district', 
      headerName: 'İlçe', 
      width: 120,
    },
    { 
      field: 'paymentMethodCode', 
      headerName: 'Ödeme Yöntemi Kodu', 
      width: 150,
    },
    { 
      field: 'priceCode', 
      headerName: 'Fiyat Kodu', 
      width: 120,
    },
    // { 
    //   field: 'priceCodeId', 
    //   headerName: 'Fiyat Kodu ID', 
    //   width: 150,
    // },
    { 
      field: 'taxNumber', 
      headerName: 'Vergi No', 
      width: 120,
    },
    { 
      field: 'taxOffice', 
      headerName: 'Vergi Dairesi', 
      flex: 1,
      minWidth: 180,
    },
    { 
      field: 'phoneNumber', 
      headerName: 'Telefon', 
      width: 130,
    },
    { 
      field: 'emailAddress', 
      headerName: 'E-Posta', 
      flex: 1,
      minWidth: 180,
    },
  ];

  return (
    <Card sx={{ p: 3 }}>
      <Box sx={{ mb: 3 }}>
        <TextField
          placeholder="Ara (Acente Adı, Vergi No, Şehir, Telefon, E-Posta vb.)"
          variant="outlined"
          fullWidth
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          size="small"
          sx={{ mb: 2 }}
        />
        <Button 
          variant="contained" 
          color="primary" 
          onClick={fetchAccounts}
          disabled={loading}
        >
          {loading ? 'Yükleniyor...' : 'Yenile'}
        </Button>
        <Box sx={{ mt: 1, color: 'text.secondary', fontSize: '0.875rem' }}>
          Toplam: {filteredAccounts.length} / {allAccounts.length}
        </Box>
      </Box>

      <Box sx={{ height: 'auto', width: '100%' }}>
        <DataGrid
          rows={filteredAccounts}
          columns={columns}
          pageSizeOptions={[]}
          disablePaginationControl
          hideFooterPagination
          autoHeight
          sx={{
            '& .MuiDataGrid-root': {
              border: 'none',
            },
            '& .MuiDataGrid-cell': {
              borderBottom: '1px solid #f0f0f0',
            },
          }}
        />
      </Box>
    </Card>
  );
};

export default AcenteLists;
